import { FormControl, FormHelperText, type SxProps } from '@mui/material';
import type { ReactElement, ReactNode } from 'react';

interface Props {
  children: ReactElement;
  error?: boolean;
  helperText?: ReactNode | string | any;
  sx?: SxProps;
}

export default function WithHelperText({ children, error, helperText, sx }: Props) {
  return (
    <FormControl
      error={error}
      sx={sx}
    >
      {children}
      {helperText && (
        <FormHelperText sx={{ marginLeft: 0, fontWeight: error ? 500 : 400, fontSize: '0.875rem' }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
